var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowDownIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 5,
    viewBox: "0 0 10 5",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.59189 4.78906L9.75513 1.22354C9.83276 1.15705 9.89434 1.07812 9.93636 0.991249C9.97837 0.904377 10 0.811269 10 0.717239C10 0.527338 9.91192 0.345215 9.75513 0.210935C9.67749 0.144446 9.58532 0.0917043 9.48389 0.0557208C9.38246 0.0197373 9.27374 0.00121732 9.16395 0.00121732C8.94221 0.00121732 8.72956 0.0766549 8.57277 0.210935L5.00071 3.27728L1.42865 0.210935C1.35125 0.144097 1.25916 0.0910462 1.15769 0.0548428C1.05623 0.0186395 0.947394 0 0.837475 0C0.727555 0 0.618724 0.0186395 0.517258 0.0548428C0.415792 0.0910462 0.323701 0.144097 0.246296 0.210935C0.168253 0.277227 0.106308 0.356097 0.0640354 0.442996C0.0217628 0.529894 0 0.623101 0 0.717239C0 0.811377 0.0217628 0.904584 0.0640354 0.991482C0.106308 1.07838 0.168253 1.15725 0.246296 1.22354L4.40953 4.78906C4.48694 4.8559 4.57903 4.90895 4.68049 4.94516C4.78196 4.98136 4.89079 5 5.00071 5C5.11063 5 5.21946 4.98136 5.32093 4.94516C5.42239 4.90895 5.51448 4.8559 5.59189 4.78906Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDownIcon);
export default __webpack_public_path__ + "static/media/arrow_down_icon.35bc54a8347debbc184c18ca7a8bad3f.svg";
export { ForwardRef as ReactComponent };